import DropdownController from "./dropdown_controller"

// Dodatkowa opcjonalna logika dla kontrolera animated-dropdown:
// Zmienna query_only jest ustawiana na true podczas połączenia kontrolera
// i przechowuje stan trybu zapytania. Metoda switchQueryMode przełącza ten stan
// i odpowiednio włącza lub wyłącza wszystkie pola formularza oprócz pola "q",
// które są wewnątrz opcjonalnego pola queryExtensionTarget.

// Connects to data-controller="animated-dropdown"
export default class extends DropdownController {
  static targets = ["button", "queryExtension"]

  connect() {
    // Po restore z cache Turbo (back/forward) pasek może wrócić rozwinięty, podczas gdy
    // switchQueryMode(true) blokuje pola - niespójny stan (menu widać, pola disabled).
    // Wymuszamy zwinięcie PRZED super.connect(), żeby baza poprawnie zainicjalizowała
    // transition (robi to tylko gdy menu ma klasę "hidden") i stan był spójny.
    if (this.hasMenuTarget && !this.menuTarget.classList.contains("hidden")) {
      this.menuTarget.classList.add("hidden")
    }
    super.connect()
    this.switchQueryMode(true)
  }

  toggle() {
    this.rotateButton()
    super.toggle()
    this.switchQueryMode()
  }

  rotateButton() {
    if (this.buttonTarget.classList.contains("rotate-0")) {
      this.buttonTarget.classList.remove("rotate-0")
      this.buttonTarget.classList.add(`rotate-${this.degreesValue}`)
    } else {
      this.buttonTarget.classList.remove(`rotate-${this.degreesValue}`)
      this.buttonTarget.classList.add("rotate-0")
    }
  }

  outsideHide(event) {
    console.log("outsideHide1", event)
    console.log("outsideHide2", event.target)

    if (event.target.closest("button[data-action=\"click->intum-select#toggleResult click->intum-select#removeBubble\"]")) {
      return
    }
    // this.hide(event)
    if (!this.element.contains(event.target) && !this.menuTarget.classList.contains("hidden")) {
      this.switchQueryMode()
      this.rotateButton()
      this.leave()
      this.removeEvent()
    }
  }

  switchQueryMode(force = null) {
    this.queryOnly = force !== null ? force : !this.queryOnly
    console.log("queryOnly mode:", this.queryOnly)

    if (this.hasQueryExtensionTarget) {
      const inputs = this.queryExtensionTarget.querySelectorAll("input, select, textarea")
      inputs.forEach(input => {
        // "q" oraz pola oznaczone data-no-disable (np. ukryty input filtra zaawansowanego)
        // muszą lecieć z formularzem także przy zwiniętym pasku - inaczej gubimy filtr
        if (input.name !== "q" && input.dataset.noDisable === undefined) {
          input.disabled = this.queryOnly
        }
      })
    }
  }
}
